import React from 'react';
import CardImage from '../../../componets/CardImage';

const AssetCard = ({ asset }: { asset: any }) =>  {
  return <CardImage
    key={asset.id}
    image={asset.image_url}
    title={asset.type}
  />
}

export default AssetCard;
